module.exports = __webpack_public_path__ + "f4eab149a108f009a63690dd47b04c44.glb";